import React, { useState } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';

const PayPalTest = () => {
  const [amount, setAmount] = useState(10);
  const [message, setMessage] = useState('');

  const paypalOptions = {
    "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
    currency: "USD",
    intent: "capture"
  };

  console.log('PayPal Test - Client ID:', process.env.REACT_APP_PAYPAL_CLIENT_ID);
  console.log('PayPal Test - Environment:', process.env.REACT_APP_PAYPAL_ENVIRONMENT);
  console.log('PayPal Test - Full Options:', paypalOptions);

  const createOrder = (data, actions) => {
    console.log('Creating PayPal order for amount:', amount);
    setMessage('Creating order...');
    
    return actions.order.create({
      intent: 'CAPTURE',
      purchase_units: [{
        amount: {
          currency_code: 'USD',
          value: amount.toString()
        },
        description: `Test donation - $${amount}`
      }]
    });
  };

  const onApprove = async (data, actions) => {
    console.log('PayPal order approved:', data);
    setMessage('Processing payment...');
    
    try {
      const order = await actions.order.capture();
      console.log('Payment successful:', order);
      setMessage(`Payment successful! Order ID: ${order.id}`);
    } catch (error) {
      console.error('Payment capture error:', error);
      setMessage(`Payment failed: ${error.message}`);
    }
  };

  const onError = (error) => {
    console.error('PayPal error:', error);
    setMessage(`PayPal error: ${error.message || 'Unknown error'}`);
  };

  const onCancel = (data) => {
    console.log('Payment cancelled:', data);
    setMessage('Payment was cancelled');
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h3>PayPal Integration Test</h3>
            </div>
            <div className="card-body">
              <div className="mb-3">
                <label className="form-label">Test Amount (USD):</label>
                <input
                  type="number"
                  className="form-control"
                  value={amount}
                  onChange={(e) => setAmount(parseFloat(e.target.value) || 10)}
                  min="1"
                  step="0.01"
                />
              </div>

              <div className="mb-3">
                <strong>Debug Info:</strong>
                <ul className="list-unstyled small text-muted">
                  <li>Client ID: {process.env.REACT_APP_PAYPAL_CLIENT_ID ? 'Set' : 'Missing'}</li>
                  <li>Environment: {process.env.REACT_APP_PAYPAL_ENVIRONMENT || 'Not set'}</li>
                  <li>Amount: ${amount}</li>
                </ul>
              </div>

              {message && (
                <div className={`alert ${message.includes('successful') ? 'alert-success' : message.includes('error') || message.includes('failed') ? 'alert-danger' : 'alert-info'}`}>
                  {message}
                </div>
              )}

              <div className="mb-3">
                <button 
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    const popup = window.open('about:blank', 'test', 'width=400,height=300');
                    if (popup) {
                      popup.document.write('<h3>Popup Test Successful!</h3><p>Your browser allows popups for this site.</p>');
                      setTimeout(() => popup.close(), 2000);
                      setMessage('✅ Popup test successful - PayPal should work');
                    } else {
                      setMessage('❌ Popups are blocked - Please allow popups for localhost');
                    }
                  }}
                >
                  Test Popup Blocker
                </button>
                <small className="text-muted">Check if popups are allowed</small>
              </div>

              <div className="mb-3">
                <h5>PayPal Payment Button:</h5>
                {process.env.REACT_APP_PAYPAL_CLIENT_ID ? (
                  <PayPalScriptProvider options={paypalOptions}>
                    <PayPalButtons
                      style={{
                        layout: 'vertical',
                        color: 'blue',
                        shape: 'rect',
                        label: 'donate'
                      }}
                      createOrder={createOrder}
                      onApprove={onApprove}
                      onError={onError}
                      onCancel={onCancel}
                    />
                  </PayPalScriptProvider>
                ) : (
                  <div className="alert alert-danger">
                    PayPal Client ID is not configured. Please check your .env file.
                  </div>
                )}
              </div>

              <div className="mt-4">
                <h6>Test Instructions:</h6>
                <ol className="small">
                  <li>Click the PayPal button above</li>
                  <li>In the popup, click "Log In"</li>
                  <li>Login with your sandbox account:
                    <div className="alert alert-info mt-2 mb-2">
                      <strong>Email:</strong> sb-owujr49025164@business.example.com<br/>
                      <strong>Password:</strong> c)('2dF3
                    </div>
                  </li>
                  <li>Complete the payment in the sandbox</li>
                  <li>Check the console for success messages</li>
                </ol>
                
                <div className="alert alert-warning mt-3">
                  <strong>Troubleshooting:</strong>
                  <ul className="mb-0 mt-2">
                    <li>Make sure popups are allowed for localhost</li>
                    <li>Try disabling ad blockers temporarily</li>
                    <li>Clear browser cache if having issues</li>
                    <li>Check console for any error messages</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayPalTest;